export const locale = {
    lang: 'nl',
    data: {
      'PRINCIPAL': {
        'TITULO': 'Enquêtestatus',
        'SUBTITULO': 'U kunt de informatie van de enquêtes die in een of meer producten van het bedrijf zijn toegepast, bekijken en opvolgen',
        'COPY_URL_RES':'URL kopiëren van SuccesGo',
      },
      'MENU_PRODUCTOS': {
        'TITULO': 'Gekochte producten',
        'CARGANDO': 'Productlijst laden',
        'NOMBREPULSO': 'Puls',
        'TIPOS': {
          'certificar': {
            'NOMBRE': 'Certificeren',
            'SUBTIPOS': {
              'v1': 'Certificeren v1',
              'v2': 'Certificeren v2.0',
              'v3': 'Certificeren v3.0',
            }
          },
          'certificacionesAdicio': {
            'NOMBRE': 'Bijkomende certificaties',
            'SUBTIPOS': {
              'v1Amco': 'AMCO',
              'v2TD': 'Fatsoenlijk werk',
              'v3PE': 'Eerste baan',
            }
          },
          'medir': {
            'NOMBRE': 'Meten',
            'SUBTIPOS': {
              'v1': 'Meet v1',
              'v2': 'Meten verbeterd',
              'v3': 'Meten + MST',
              'v4': 'Meten per gebied',
              'v5': 'Meten door leiders',
              'v6': 'Meten op afmetingen',
              'v7': 'Maatregel om te certificeren:',
              'v8': 'Meet 3.0',
            }
          },
          'pulse': {
            'NOMBRE': 'Druk op Controleren',
            'SUBTIPOS': {
              'v1': 'Pulscontrole v1.0',
              'v2': 'Pulscontrole v3.0',
            }
          },
          'focus': {
            'NOMBRE': 'Focusgebied',
            'SUBTIPOS': {
            }
          },
          'nom35': {
            'NOMBRE': 'NOM-035',
            'SUBTIPOS': {
              'v1': 'NOM-035',
              'v2': 'NOM-035 v3',
            }
          },
          'cgoExpress': {
            'NOMBRE': 'Culturele Go Express',
            'SUBTIPOS': {
              'cgoExpress': 'Culturele Go Express'
            }
          },
          'resulGoFlow': {
            'NOMBRE': 'goFlow resultaten',
            'SUBTIPOS': {
              'resulGoFlow': 'goFlow resultaten'
            }
          },
        }
      },
      'DETALLES': {
        'TITULO': 'Productdetails',
        'PRODUCTO': 'Product:',
        'PROGRESO': 'Vooruitgang',
        'RESTANTE': 'Overgebleven tijd',
        'DIASREST': 'Resterende dagen:',
        'PANELFIJO': 'Toon als vast paneel',
        'SURVEYTOKEN': 'Enquêtetoken',
        'ACCOUNT_ID': 'Account ID',
        'OPORTUNITY_ID': 'ID kans',
        'FECHAS': {
          'lanzamiento': 'Publicatiedatum',
          'cierre': 'Deadline',
          'prorroga': 'Verlengingsdatum',
          'recordatorio':'Herinneringen',
          'avisos':'Communicatie vóór de enquête',
        },
        'AVANCES': {
          'NORMAL': 'Voorafgaande reacties:',
          'MAS50': 'Voorschot boven de 50:',
          'MAS50_2': 'Meer dan 50 - Geavanceerde antwoorden',
          'MENOS50': 'Voorschot minder dan 50:',
          'MENOS50_2': 'Minder dan 50 - Geavanceerde reacties'
        }
      },
      'CONTENIDO': {
        'BOTONES': {
          'VERPROD_1': 'Kies een product',
          'VERPROD_2': 'Zie een ander product',
          'OCULTAR': 'Zich verstoppen'
        },
        'PREVIA': {
          'TITULO': 'Enquêtestatus per product',
          'SUBTITULO': 'De lijst met producten die door dit bedrijf zijn gekocht, wordt weergegeven in het menu aan de linkerkant van dit scherm. Om de enquêtestatus voor elk product te zien, klikt u op een productcategorie en kiest u vervolgens een jaar. Hierna worden de details van de geselecteerde enquête weergegeven, alleen als het geselecteerde product al een geïnitialiseerde enquête heeft',
          'CARGANDO': 'Status van het geselecteerde product ophalen, even geduld aub'
        },
        'ESTADOS': {
          'NOCREADA': 'Er is nog geen enquête gemaakt voor dit product',
          'NOINICIADA': 'Enquête niet ingeschakeld'
        },
      },
      'COLABORADORES': {
        'TAB': 'Lijst met medewerkers',
        'CARGANDO': 'Lijst met medewerkers laden',
        'TABLA': {
          'TITULO': 'Lijst met medewerkers',
          'NOINFO': 'Geen informatie',
          'COLUMNAS': {
            'NOMBRE': 'Voor-en achternaam',
            'EMAIL': 'E-mail',
            'PASS': 'Wachtwoord',
            'STATUS': 'Werkelijke staat',
            'FECHA_INI': 'Startdatum',
            'FECHA_FIN': 'Eind datum',
            'ACCIONES': 'Acties'
          },
          'TOOLTIPS': {
            'ACCIONES': 'Beschikbare Acties',
            'EMAILS': 'E-maillogboek',
          },
        },
        'ACCIONES': {
          'TITULO': 'Beschikbare Acties',
          'LISTA': {
            'primerosColab': 'Zie eerste 1000',
            'buscarColab': 'Zoek een medewerker',
            'nuevoColab': 'Nieuwe bijdrager toevoegen',
            'enviaReco': 'Herinneringen verzenden',
            'bajarColab': 'Lijst met medewerkers downloaden',
          }
        },
        'SENDGRID': {
          'TITULO': 'Logboek verzonden e-mail',
          'SUBTITULO': 'Kies een onderwerptype uit de lijst om de geschiedenis van verzonden e-mails weer te geven',
          'SELOPC': 'Kies een optie',
          'INFOASUNTO': {
            'TITULO': 'Mail informatie',
            'CARD': {
              'from': 'Verzenden naar',
              'to': 'Van',
              'subject': 'Bericht Onderwerp'
            },
            'HISTORIAL': {
              'TITULO': 'E-mail indieningsgeschiedenis',
              'SUBTITULO': 'OPMERKING: De datum / tijd die in de lijst wordt weergegeven, is ingesteld op lokale tijd van',
              'VECESABIERTO': 'Openingstijden',
              'ULTIMOEVENTO': 'Laatste evenement',
              'NORECORDS': 'Uw e-mailgeschiedenis is niet beschikbaar',
              'STATUS': {
                'ABIERTO': 'Email verzonden',
                'NOENVIADO': 'Nog niet verzonden'
              }
            }
          },
          'BOTONES': {
            'BACK': 'Ga terug'
          }
        },
        'ACCIONESUSUARIO': {
          'TITULO': 'Beschikbare Acties',
          'SUBTITULO': 'De volgende lijst toont de lijst met acties die beschikbaar zijn voor de gebruiker',
          'CARGANDO': 'Beschikbare acties laden',
          'LISTA': {
            'modificar': 'Wijzig de gegevens van de geselecteerde bijdrager',
            'borrar': 'De geselecteerde bijdrager verwijderen',
            'invitacion': 'Verstuur de uitnodiging opnieuw',
            'recordatorio': 'Herinnering opnieuw verzenden',
            'respuestas': 'Enquêtereactie verwijderen',
            'resetSur': 'Toegang tot enquête resetten',
          }
        },
        'MODALES': {
          'BUSCAR': 'Voer de naam in van de bijdrager om te zoeken',
          'BUSCAR_BOT': 'Zoeken',
          'MINIMARECO': 'Herinneringen kunnen alleen worden verzonden vanaf de startdatum van de enquête',
          'GENERAEXCEL': 'Excel-bestand van medewerkers genereren, wacht even',
          'NOANSWERS': 'Er zijn geen antwoorden gevonden voor deze deelnemer',
          'ENVIOCORREO': 'Het bericht wordt verzonden, wacht even',
          'BORRARESP': 'Reacties van deze gebruiker worden verwijderd, een ogenblik geduld a.u.b.',
        },
        'EXCEL': {
          'TITUARCHIVO': 'Lijst met medewerkers',
          'COLUMNAS': {
            'name': 'Naam medewerker',
            'email': 'E-mail',
            'id_status': 'Enquêtestatus',
            'start_date': 'Startdatum',
            'end_date': 'Eind datum',
          }
        }
      },
      'ACCIONES': {
        'TAB': 'Acties',
        'TITULO': 'Lijst met beschikbare acties per categorie',
        'CATEGORIAS': {
          'encuesta': 'Enquête',
          'filemanager': 'Bestandsbeheer',
          'resultados': 'Resultaten',
          'cultureaudit': 'Culture Audit',
          'webcompro': 'bedrijfsprofiel op het web',
        },
        'LISTA': {
          'surveyCheck': 'De enquête controleren',
          'surveyDown': 'Enquête downloaden',
          'goSurvey': 'Ga naar enquête',
          'goCounting': 'Ga naar het Tellingenportaal',
          'goCounting_more50': 'Ga naar de Tellingen Portal +50',
          'goCounting_less50': 'Ga naar het Tellingenportaal -50',
          'genCountingUrl': 'Genereer een externe link naar de Counts Portal',
          'copyCountingUrl': 'Kopieer externe link naar het Tellingen-portaal',
          'updateCounting': 'Synchroniseren met Counts-portal',
          'addPro': 'Voeg extensie toe',
          'verRecord': 'Opgenomen herinneringen',
          'surveyClose': 'Enquête sluiten',
          'surveyOpen': 'Enquête openen',
          'processRes': 'Procesresultaten',
          'goPriv': 'Privé map bekijken',
          'goPub': 'Openbare map bekijken',
          'verRes': 'Bekijk resultaten',
          'upNameIcon': 'Bijwerken naam en logo',
          'regCertifi': 'Regenerate certificate',
          'goSurveyMas50': 'Ga naar enquête +50',
          'goSurveyMenos50': 'Ga naar enquête -50',
          'auditMan': 'Handmatige controle',
          'libeCultureBrief': 'Cultuur Briefwisseling',
          'lockRes': 'Resultaten vergrendelen',
          'verCultureAudit': 'Zie Cultuur Audit',
          'verAvisos':'Mededeling vóór de enquête',
          'enviaCorreos': 'Handmatig e-mails verzenden',
          'verWebComPro': 'Bekijk bedrijfsprofiel op het web',
          'verFechIniCie': 'Start / einddatum',
          'cancelarEnvios': 'Annuleer het verzenden van e-mails',
          'verConfigResult': 'Resultaat configuratie',
          'descaDemo': 'Demografische gegevens kunnen worden gedownload',
          'crearClave':'Sleutel aanmaken voor extern bedrijfsprofiel',
          'copyClave':'Sleutel kopiëren naar extern bedrijfsprofiel',
          'verDatWPC':'Bekijk externe toegangsgegevens bedrijfsprofiel',
          'confirReviCultureAudit':'Controle van de cultuur bevestigen',
        },
        'MODALES': {
          'URL': 'Link gekopieerd naar klembord',
          'URL_CLA': 'De sleutel werd gekopieerd naar het klembord',
          'CHANGE_RESULT': 'Resultaten laden',
          'LOADINGMASTER': 'Informatie ophalen uit de Master Table, even geduld a.u.b.',
          'CONFIR_UPDA_NAM':'Weet u zeker dat u de naam en het logo wilt updaten?',
          'CONFIR_REG_CERT': 'Weet u zeker dat u het certificaat wilt regenereren?',
          'SUCC_UPDA_NAME':'Met succes bijgewerkt',
          'UPDA_NAME_ICON':'Gegevens bijwerken',
          'UPDA_STA_ENC':'Bijwerken van de enquêtestatus',
          'OBT_DAT_AUD_AUT':'Verkrijgen van controle-informatie',
          'WARNI_NOT_EXIT_TOKEN':'Fout: token bestaat niet in MT',
          'CONFIR_REPRO_RESULT': 'Weet u zeker dat u de resultaten opnieuw wilt verwerken?',
          'MOD_INGRE_COD_PT1':'<span> Ter bevestiging voert u de code in rood in het tekstvak in ',
          'MOD_INGRE_COD_PT2':'</span>',
          'ERROR_CODIGO': 'De ingevoerde code komt niet overeen met de in het rood aangegeven code',
          'CONFIR_LIBE_CULT_BRI': 'Weet u zeker dat u de cultuurbrief wilt vrijgeven?',
          'CONFIR_REVI_CULT_AUDIT':'Weet u zeker dat u het cultuuronderzoek wilt bevestigen?',
          'NO_CONFIR_REVI_CULT_AUDIT':'Weet u zeker dat u het cultuuronderzoek wilt annuleren?',
          'NO_CULT_BRI_ASOC':'Een cultuur audit partner kan niet gevonden worden',
          'BLOQUEAR_1_1': 'Resultaten zijn momenteel ontgrendeld \nWilt u resultaten vergrendelen?',
          'BLOQUEAR_1_2': 'Voer de reden in waarom de resultaten zijn geblokkeerd',
          'BLOQUEAR_2_1': 'Resultaten zijn momenteel vergrendeld \nWilt u de resultaten ontgrendelen?',
          'BLOQUEAR_2_2': 'Schrijf de reden waarom de resultaten zijn ontgrendeld',
          'BLOQUEAR_3_1': 'Het is noodzakelijk om de reden voor de wijziging op te geven',
          'SINCRONIZARMT': 'De gegevens van de Master Table worden gesynchroniseerd, even geduld a.u.b.',
          'UPDA_DAT_RECOR': 'De herinneringsdatum bijwerken',
          'DELE_DAT_RECOR': 'De herinneringsdatum verwijderen',
          'UPDA_DAT_AVI': 'Kennisgeving Datum Update',
          'DELE_DAT_AVI': 'Opzeggingsdatum schrappen',
          'CANCELAR_ENVIOS': 'Weet je zeker dat je geplande e-mails wilt annuleren?',
          'CANCELAR_ENVIOS_OK': 'De verzending is succesvol geannuleerd.',
          'CANCELAR_ENVIOS_ERROR': 'Het is niet mogelijk om de levering minder dan twee uur voor aanvang van de enquête te annuleren.',
          'COM_CRE_ACCE_WCP_EXT': 'Weet u zeker dat u de sleutel voor het bedrijfsprofiel wilt maken?',
          'CRE_ACCE_WCP_EXT': 'Wachtwoord aan het genereren',
          'SUCC_CRE_ACCE_WCP_EXT': 'Wachtwoord succesvol gegenereerd',
          'TIT_MOD_VALI_ACCE_WCP_EXT': 'Om verder te gaan: Voer uw wachtwoord in.',
          'PLA1_MOD_VALI_ACCE_WCP_EXT': 'U hebt momenteel nog ',
          'PLA2_MOD_VALI_ACCE_WCP_EXT': ' pogingen over',
          'BTN_ACEP': 'Accepteren',
          'BTN_CAN': 'Annuleren',
          'WAR_ACCE_WCP_EXT': 'Het ingevoerde wachtwoord is niet correct',
          'LIMI_ACCE_WCP_EXT': 'U hebt de limiet van pogingen bereikt',
          'DESAC_ACCE_WCP_EXT': 'Uw bedrijfsprofiel is momenteel uitgeschakeld',
          'ACTU_ACCE_WCP_EXT': 'Informatie aan het bijwerken',
          'SUCC_ACTU_ACCE_ACCE_WCP_EXT': 'Succesvol bijgewerkt',
          'CHANGE_WCP':'Bedrijfsprofiel laden',
        },
        'SUBACCIONES': {
          'TITULO': 'Klik hier om meer beschikbare acties te zien',
          'AUDMANUAL': {
            'TITULO': 'Handmatige controle',
            'NOMBRE': 'Naam accountant',
            'NOTAS': 'waarnemingen',
            'STATUS': {
              'ON': 'Audit geaccepteerd',
              'OFF': 'Audit afgewezen'
            }
          },
          'verRes': {
            'tipoResu': {
              'TITULO': 'Versietype van resultaten wijzigen',
              'MODAL': {
                'TITULO': 'Selectie van versietype',
                'SUBTITULO': 'Selecteer het type resultatenversie voor dit product',
                'SINCERT': 'Versie zonder certificaat',
                'CONCERT': 'Versie met certificaat'
              }
            },
            'tipoResuV2': {
              'TITULO': 'Zie resultaten versie 2',
            },
          },
          'regCertifi': {
            'logoCert': {
              'TITULO': 'Certificaatlogo wijzigen',
            },
            'previewCert': {
              'TITULO': 'Certificaatvoorbeeld',
            },
            'multiSite': {
              'TITULO': 'Certificaattekst voor meerdere locaties inschakelen',
            },
            'multiSiteText': {
              'TITULO': 'Certificaattekst voor meerdere locaties bekijken',
            },
          },
          'upNameIcon': {
            'logoEmpresa': {
              'TITULO': 'Bedrijfslogo wijzigen'
            },
            'previewLogoEmp': {
              'TITULO': 'Logovoorbeeld'
            },
            'updateDatCerti': {
              'TITULO': 'Datum certificaat wijzigen',
            }
          },
          'masterTable': {
            'syncMT': {
              'TITULO': 'Hoofdtabel synchroniseren'
            }
          },
          'crearClave': {
            'visibleSwitchWCP': {
              'TITULO': 'Status zie extern bedrijfsprofiel',
            }
          },
          'verDatWPC': {
            'visibleSwitchWCP': {
              'TITULO': 'Status zie extern bedrijfsprofiel',
            }
          },
          'verWebComPro': {
            'updateStatusWCP': {
              'TITULO': 'Status zie bedrijfsprofiel op de website',
            },
            'ESTA_WPC':{
              'ESTA_WPC_PU':'Publiek',
              'ESTA_WPC_NPU':'Niet-openbaar',
            },
          },
        }
      },
      'HISTORIAL_MAILS': {
        'TAB': 'Geschiedenis van verzonden e-mails',
        'TITULO': 'Lijst met verzonden e-mails voor dit product',
        'TABLA': {
          'DESTINATARIO': 'Geadresseerde',
          'ASUNTO': 'Mail onderwerp',
          'ESTADO': 'Huidige status',
          'VECES': 'Aantal keren geopend',
          'ULTIMO': 'Datum van het laatste evenement',
          'FILTRO': 'Filter',
          'INPUT_DEST': 'Filteren op e-mailadres',
          'INPUT_ASU': 'Filteren op onderwerp',
          'INPUT_STAT': 'Filteren op status',
          'ELIJAOPCION': '- Kies een optie uit de lijst -',
          'NORESULTS': 'Geen verslagen gevonden',
          'LISTA_STATUS': {
            'delivered': 'Verzonden',
            'processed': 'In verzendproces',
            'not_delivered': 'Niet verzonden'
          }
        },
        'ACCIONES': {
          'TITULO': 'Beschikbare Acties',
          'LISTA': {
            'enviaCorreos': 'Handmatig e-mails verzenden',
            'getEnviados': 'Update e-mails verzendgeschiedenis',
          }
        },
        'MODAL': {
          'TITULO': 'Handmatige mailing',
          'SUBTITULO': 'U kunt direct handmatige mailings van een bepaald type naar medewerkers in deze enquête sturen',
          'INPUT': 'Selecteer een e-mailtype',
          'TIPOS': {
            '1': 'Uitnodiging e-mail',
            '2': 'Herinneringsmail',
            '3': 'Eerste kennisgeving voorafgaand aan de lancering van de enquête',
            '4': 'Tweede kennisgeving voorafgaand aan de lancering van de enquête',
            '5': 'Mail sluiten',
            '6': 'E-mail verzonden naar bijdragers die de enquête nog niet hebben gestart',
            '7': 'E-mail verzonden naar bijdragers die zijn begonnen maar nog niet klaar zijn'
          },
          'BOTONES': {
            'BACK': 'Ga terug',
            'CONTINUAR': 'Doorgaan met',
            'SAVE': 'Save audit',
          }
        },
        'MODALES': {
          'RECUPERANDO': 'Lijst met verzonden e-mails ophalen, wacht even',
          'SEND_EMA':'Mails werden gesendet',
          'SUCC_SEND_EMA':'Die Mails wurden erfolgreich versendet',
          'CONFIRMAR': 'Bevestigt u het verzenden van de e-mails van het geselecteerde type naar de medewerkers van deze enquête?',
          'ENVIADOS': 'De e-mails zijn succesvol verzonden, update de geschiedenis binnenkort om de verzonden e-mails te zien',
          'SI': 'Ja',
          'NO': 'Nee',
          'UPDAT_HIST_EMA': 'Geschiedenis wordt bijgewerkt',
          'SUCC_UPDAT_HIST_EMA': 'Succesvol bijgewerkt',
          'WAR_SEL_MAI': 'Om verder te gaan, selecteer een mail type',
          'WAR_SQL_ERROR': 'De reactietijd is verstreken, probeer het opnieuw.',
        },
        'RESUMEN': {
          'TITULO': 'Overzicht',
          'TIPOS': {
            'totalEnviados': 'Totaal aantal gestarte mailings',
            'delivered': 'Correcte mailings',
            'processed': 'Mailings in behandeling',
            'not_delivered': 'Mailings niet gemaakt',
          }
        }
      },
      'AUDITORIA':{
        'TAB_TIT_AUDI':'Enquête-audit',
        'TEX_AUDI_NOT_AUTORI': 'Audit geweigerd!',
        'TEX_AUDI_YE_AUTORI': 'Audit aanvaard!',
        'TITL_AUDI_DEV_TR':'% Dev.Time Response',
        'TITL_AUDI_DEV_PC':'% Dev. Vraag Controle',
        'TITL_AUDI_DEV_PA':'% Willekeurige vraag Dev. Willekeurig',
        'TIT_PAGI_TABL':'Artikelen per pagina:',
        'COLUMNAS':{
          'HierarchicalPath':'Structuur',
          'RespondentCount':'# Antwoorden',
          'Time_DeviationCount':'# Desv T.Resp',
          'Time_DeviationPercentage':'% Desv T.Resp',
          'ControlStatement_DeviationCount':'# Desv P.Controle',
          'ControlStatement_DeviationPercentage':'% Desv P.Controle',
          'RandomStatement_DeviationPercentage':'# Desv P.Willekeurig',
          'RandomStatement_DeviationCount':'% Desv P.Willekeurig',

        }
      },
      'EMAI_LOG':{
        'TAB': 'Algemene postgeschiedenis',
        'TABLA_GLOBAL':{
          'TITU': 'Globale weergave',
          'SUB_TIT': 'Totaal bijdragers',
          'TH_1':'Status',
          'TH_2':'Eerste melding',
          'TH_3':'Tweede melding',
          'TH_4':'Uitnodiging',
          'TH_5':'Herinnering aan niet-opgestarte gebruikers',
          'TH_6':'Herinnering voor niet-afgeronde gebruikers',
          'enviados': 'Verzonden',
          'procesando':'Verwerkt',
          'error': 'Fout',
          'VIE_DETA_TOOL':'Details bekijken',

        },
        'TABLA_COLAB':{
          'TITU_AV1_DELIV': 'Weergave van verzonden type waarschuwing 1 van mail',
          'TITU_AV1_PROCC':'Weergave type mail waarschuwing 1 in behandeling',
          'TITU_AV1_N_DELIV': 'Weergave type mail waarschuwing 1 in fout',

          'TITU_AV2_DELIV': 'Weergave type mailwaarschuwing 2 verzonden',
          'TITU_AV2_N_DELIV': 'Weergave type mailwaarschuwing 2 in fout',
          'TITU_AV2_PROCC': 'Weergave type 2-kennisgeving 2 post in behandeling',

          'TITU_INV_DELIV': 'Weergave type mail uitnodiging verzonden',
          'TITU_INV_PROCC': 'Weergave type uitnodiging mail in behandeling',
          'TITU_INV_N_DELIV': 'Weergave type post uitnodiging foutief',

          'TITU_REC1_DELIV': 'Weergave verzonden herinneringsmail type 1',
          'TITU_REC1_PROCC':'Weergave type aanmaningsmail 1 in behandeling',
          'TITU_REC1_N_DELIV': 'Weergave herinnering 1 type foutieve post',

          'TITU_REC2_DELIV': 'Weergave herinnering post type 2 verzonden',
          'TITU_REC2_N_DELIV':'Weergave herinnering post type 2 in fout',
          'TITU_REC2_PROCC': 'Weergave aanmaningsmail type 2 in behandeling',
          'SUB_TIT':'Totaal medewerkers',
          'TH_1':'Status',
          'TH_2':'Naam medewerker',
          'TH_3':'Bericht',
          'TH_4':'Datum laatste e-mail',
          'TH_5':'Totaal aantal e-mails',
          'TH_6':'Actie',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'TEX_SEARC_COLAB':'Vul naam of e-mail in',

        },
        'TEX_MOD_CHA_INFO':'Informatie laden',
        'CONT_MOD':{
          'TAB_TIT1': 'Mail status',
          'TAB_TIT2': 'Mailweergave',
          'TEX_CHA_INFO_GRAL': 'Informatie laden',
          'TEX_ASUN': 'Onderwerp: ',
          'TEX_SELEC_EMA': 'Selecteer een e-mail',
          'TEX_CHA_INFO_EMA': 'Mailinformatie wordt geladen',
          'H1_TIT_EMA_INFO': 'E-mail informatie',
          'SPAN_SUB_TIT_DET': 'details',
          'TO':'Aan:',
          'FROM':'Van:',
          'SUBJE': 'Onderwerp',
          'MESS_ID': 'Bericht-ID:',
          'BTN_VER_MAS': 'Meer details',
          'BTN_VER_MEN': 'Minder details',
          'TIT_TEX_LIS': 'Voorvalgeschiedenis',
          'SPAN_RECIV_SENGR': 'Ontvangen door SendGrid',
          'SPAN_RECIV_FROM':'Ontvangen door ',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'deferred':'Deferred',
          'blocked':'blocked',
          'SPAN_DES_OPE_EMA':'De ontvanger heeft deze mail geopend',
          'REASON':{
           'Bounced Address':'Gebounced adres',
          }

        }
      },
      'DAT_CERTI':{
        'TIT_MOD': 'Datum certificaat wijzigen',
        'ING_DAT': 'Selecteer datum:',
        'ING_RAS': 'Reden voor wijziging datum opgeven:',
        'BTN_SAV': 'Wijzigingen opslaan',
        'BTN_OK': 'OK',
        'MOD_ING_REA': 'Reden voor wijziging datum invoeren',
        'MOD_UPD_DAT': 'Datum certificaat aan het bijwerken',
        'SUCC_MOD_UPD_DAT': 'Succesvol bijgewerkt',

      },
      'DAT_STAEND':{
        'TIT_MOD': 'Begin- en einddatum van de enquête',
        'SUB_TIT_MOD': 'Elke datum wordt weergegeven in lokale tijd in ',
        'TEX_DA_STA': 'Begindatum',
        'TEX_DA_EN': 'Einddatum',
        'MOD_UPD_DA_STA': 'Publicatiedatum bijwerken',
        'MOD_UPD_DA_EN': 'Einddatum bijwerken',
        'SUCC_MOD_UPD_DA_DA_STA': 'Succesvol bijgewerkt',
        'SUCC_MOD_UPD_DA_DA_EN': 'Met succes bijgewerkt',


      },
      'LANG_CERT':{
        'TIT_MOD':'Kies taal:',
      },
    }
};
